module.exports = __webpack_public_path__ + "static/media/noun_pause_1948186-3.5e595eff.svg";